const LOCAL_INTENT_LABELS: Record<string, string> = {
  local_recommendation: "Local Recommendations",
  local_service_specific: "Category / Service Match",
  local_trust_review: "Trust & Reviews",
  local_emergency: "High-Intent Need",
  local_problem_solution: "Research / Need-State",
  local_cost_value: "Price / Value",
  local_comparison: "Direct Comparison",
  dealer_recommendation: "Dealer Recommendation",
  dealer_inventory: "Dealer Inventory",
  dealer_used_cpo: "Dealer Used / CPO",
  dealer_financing_tradein: "Dealer Financing / Trade-In",
  dealer_service_center: "Dealer Service Center",
  dealer_reputation: "Dealer Reputation",
  dealer_comparison: "Dealer Comparison",
  project_recommendation: "Project Recommendations",
  project_service_match: "Project Service Match",
  project_quality_craftsmanship: "Quality / Craftsmanship",
  project_before_hiring: "Before Hiring",
  project_price_value: "Project Price / Value",
  project_trust_review: "Project Trust & Reviews",
};

export function formatLocalIntentLabel(category?: string | null): string {
  if (!category) return "Uncategorized";
  return LOCAL_INTENT_LABELS[category] || category.replace(/_/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
}
